var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-jumbo-image"},[_c('img',{attrs:{"src":("/" + (_vm.image.imagePath))}})])}
var staticRenderFns = []

export { render, staticRenderFns }